import React from 'react';
import { Svg } from '../../1_Atoms/Svg/Svg';
import { languageController } from '../../../controllers/language/languageController';

interface AutoCompleteResult {
  id: string | number;
  label: string;
  [key: string]: any;
}

interface AutoCompleteProps {
  input: React.ReactNode;
  results: AutoCompleteResult[];
  onClick: (result: AutoCompleteResult) => void;
  onReset: () => void;
  isActive: boolean;
  isSelected: boolean;
}

const AutoComplete: React.FC<AutoCompleteProps> = ({
  input,
  results,
  onClick,
  onReset,
  isActive,
  isSelected
}) => {
  return (
    <div className="mz-auto-complete">
      {input}
      <div className="mz-auto-complete__icon">
        {
          isSelected ? (
            <button
              className="mz-auto-complete__reset reset font-base medium"
              onClick={onReset}
            >
              {languageController.getCopy('global', 'change')}
            </button>
          ) : (
              <Svg type="search" size={1.3} colour="grey" />
            )
        }
      </div>
      <div className="mz-auto-complete__results" aria-hidden={!isActive}>
        {
          results.length > 0 ? (
            results.map(result => (
              <a key={result.id} className="mz-auto-complete__item" onClick={() => onClick(result)}>{result.label}</a>
            ))
          ) : (
              <div className="mz-auto-complete__empty-message">{languageController.getCopy('global', 'noResults')}</div>
            )
        }
      </div>
    </div>
  );
};

export default AutoComplete;
